<div
  class="ticket-main container"
  [ngClass]="{
    'mt-mb':
      ticketService.isLocal?.value == true ||
      ticketService.isLocal?.value == false
  }"
  *ngIf="
    ticketService.isLocal?.value == true ||
    ticketService.isLocal?.value == false
  "
>
  <div class="ticketItems row">
    <div
      class="col-md-3 ticketItem"
      *ngFor="let ticket of this.ticketService.mappingAfterTicket$.value"
    >
      <ticket-item2 [ticket]="ticket"></ticket-item2>
    </div>
    <div class="container stadium-text-wrapper" *ngIf="showBottomText">
      <div class="stadium-text">
        {{
          "Stadium entrance is free when you buy a park entrance ticket"
            | translate
            | async
        }}
      </div>
    </div>
  </div>
</div>
<!-- eğer local seçilmemişse -->
<div
  class="islocal-main"
  *ngIf="
    ticketService.isLocal?.value == undefined &&
    !this.appService.settings$.value?.DEFAULTFOREIGNROUTE
  "
  [ngStyle]="{
    'background-image': this.appService.settings$.value
      ?.TICKET_PAGE_BACKGROUND_URL
      ? 'url(' +
        this.appService.settings$.value?.TICKET_PAGE_BACKGROUND_URL +
        ' )'
      : 'none'
  }"
  [ngClass]="{
    'img-div': this.appService.settings$.value?.TICKET_PAGE_BACKGROUND_URL
  }"
>
  <div class="islocal" style="width: 60%; margin: auto; padding: 40px 0">
    <div class="local-div row">
      <div class="local-main col-md-6">
        <div
          class="local-container border-radius"
          (click)="isLocalCheck(false)"
        >
          <div class="local-title">SPECIAL ONLINE PRICES</div>
          <div class="local-title">Специальные онлайн-цены</div>
        </div>
      </div>
      <div class="local-main col-md-6">
        <div
          class="local-container tc"
          (click)="isShowTcValidate = !isShowTcValidate"
          [ngClass]="
            isShowTcValidate ? 'border-top-lr-radius' : 'border-radius'
          "
        >
          <div class="local-title">İNDİRİMLİ YEREL FIYATLAR</div>
          <div class="local-title">HEMEN TIKLAYIN, YAKALAYIN</div>
        </div>
        <div
          class="tc-validation"
          [ngClass]="
            isShowTcValidate
              ? 'tc-validation-show border-bottom-lr-radius'
              : 'tc-validation-hide'
          "
        >
          <div>
            <ta-basic-input
              [isSubmit]="isSubmitTC"
              [formControlFunc]="ticketFormControl"
              [inputType]="'string'"
              [inputLabel]="'Identity Number'"
            ></ta-basic-input>
          </div>
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;
            "
          >
            <button
              class="ticket-main-button"
              type="submit"
              (click)="validationTC()"
            >
              Devam Et
            </button>
            <div style="color: red; margin-top: 10px">
              Girmiş olduğunuz T.C. kimlik numarası veri tabanına
              KAYDEDİLMEMEKTEDİR.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="this.appService.settings$.value?.PHONE_NUMBER"
      class="row phone-div"
      [ngStyle]="{ 'margin-top': isShowTcValidate ? '0px' : '-80px' }"
    >
      <div style="text-align: center">
        <a
          class="phone"
          href="tel:{{ this.appService.settings$.value?.PHONE_NUMBER }}"
          style="color: white"
        >
          <i
            class="fas fa-phone-alt"
            style="transform: rotate(100deg); margin-right: 5px"
          ></i
          >{{ this.appService.settings$.value?.PHONE_NUMBER }}
        </a>
      </div>
    </div>
  </div>
</div>

<!-- basket -->
<section id="basket">
  <div
    id="basket"
    [ngStyle]="{
      opacity: basketService.basket$?.value ? '1' : '0'
    }"
  >
    <!-- <div class="basket-icon" (click)="isOpenSidebarBasketFunc()">
      <i
        class="fa-solid fa-basket-shopping"
        style="font-family: 'Font Awesome 6 Free' !important"
      ></i>
    </div> -->
  </div>

  <div
    id="overlay"
    (click)="isOpenSidebarBasketFunc()"
    [ngStyle]="{ display: isOpenSidebarBasket ? 'block' : 'none' }"
  >
    &nbsp;
  </div>
  <!-- sidebar -->
  <div
    id="basket-sidebar"
    [ngStyle]="{
      transform: isOpenSidebarBasket ? 'translateX(0)' : 'translateX(100%)'
    }"
  >
    <div class="basket-sidebar-header row">
      <div class="basket-sidebar-header-title col-6">
        <span>Sepetim</span>
      </div>
      <div class="basket-sidebar-header-close col-6">
        <div class="header-close-icon" (click)="isOpenSidebarBasketFunc()">
          <i
            class="fa-solid fa-x"
            style="font-family: Font Awesome 6 Free !important"
          ></i>
        </div>
      </div>
    </div>
    <div class="basket-sidebar-content row">
      <div class="basket-sidebar-items">
        <div
          class="basket-sidebar-item"
          *ngFor="
            let basketItem of basketService.basket$?.value?.ITEMS.TICKETITEMS
          "
        >
          <basket-sidebar-item [basketItem]="basketItem"></basket-sidebar-item>
        </div>
      </div>
    </div>
  </div>

  <!-- center basket -->
  <div
    id="basket-center-main"
    [ngStyle]="{
      transform: isOpenSidebarBasket
        ? 'translateY(0)'
        : 'translateY(calc(100% + 10px))'
    }"
    *ngIf="basketService.basket$?.value"
  >
    <div id="basket-center">
      <div class="basket-center-header row">
        <div class="basket-center-header-title col-6">
          <span>Rezervasyonlarım </span>
        </div>
        <div class="basket-center-header-close col-6">
          <div class="header-close-icon" (click)="isOpenSidebarBasketFunc()">
            <i
              class="fa-solid fa-x"
              style="font-family: Font Awesome 6 Free !important"
            ></i>
          </div>
        </div>
      </div>
      <div class="basket-center-content row">
        <div class="basket-center-items">
          <div
            class="basket-center-item"
            *ngFor="
              let basketItem of basketService.basket$?.value?.ITEMS.TICKETITEMS
            "
          >
            <reservation-item
              [basketItem]="basketItem"
              (deleteItem)="deleteItem($event)"
            ></reservation-item>
          </div>
        </div>
      </div>
      <div class="basket-center-footer">
        <div class="row">
          <div class="col-md-6 basket-center-total-price">
            <div class="">
              Toplam {{ basketService.basket$?.value?.TOTALBASKETPRICE }}
              {{ basketService.basket$?.value.CURRENCY }}
            </div>
          </div>
          <div
            class="col-md-6 button-div"
            routerLink="/basket"
            (click)="isOpenSidebarBasketFunc()"
          >
            <button class="button-center">Rezervasyonu Tamamla</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
